

<script>
import viewWideEquation from '@/components/mixins/WideEquation.vue'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      selector: this.uniqueKey,
      isCorrect: null,
      exHints: [{hints: [{}]}],
      exSolutions: [{solution: [{}]}],
      doShowSolution: false,
      solutionKey: 'modal-solution-' + this.uniqueKey,
      hintKey: 'modal-hint-' + this.uniqueKey,
      submitInfo: {
        entireQuestion: this.CelotnoVprasanje,
        exerciseVersionId: this.exerciseVersionId,
        yearId: this.$route.params.yid,
        hintNumber: 0,
        sid: this.$route.params.sid,
        classExamId: this.$route.params.classExamId,
        selectedAnswer: this.CelotnoVprasanje.correct || ((this.isSurvey() || this.isExam) ? this.CelotnoVprasanje.submittedAnswer.answer : undefined) || []
      },
      submitted: false
    }
  },
  props: {
    CelotnoVprasanje: Object,
    exerciseVersionId: Number,
    uniqueKey: String,
    enableOptions: Object
  },
  mounted () {
    if (this.CelotnoVprasanje.submittedAnswer) {
      this.submitInfo.selectedAnswer = this.CelotnoVprasanje.submittedAnswer.answer
      this.submitted = true
    }
    this.CelotnoVprasanje.text[this.lng] = this.renderSiroko(this.CelotnoVprasanje.text[this.lng]) // begin siroko, end siroko
    if (this.CelotnoVprasanje.submittedAnswer && this.CelotnoVprasanje.type === 'radio') {  // shranjeni odgovor za RADIO
      window.jQuery('input[value="' + this.submitInfo.selectedAnswer + '"]').iCheck('check')
    } else if (this.CelotnoVprasanje.submittedAnswer && this.CelotnoVprasanje.type === 'multichoice') { // shranjeni odgovori za MULTICHOICE
      for (let i = 0; i < this.CelotnoVprasanje.submittedAnswer.answer.length; i++) {
        window.jQuery('input[value="' + this.CelotnoVprasanje.submittedAnswer.answer[i] + '"]').iCheck('check')
      }
    }
    if ('correct' in this.CelotnoVprasanje) {
      this.isCorrect = true
    }
    this.typeSet()
  },
  mixins: [viewWideEquation],
  computed: {
    ...mapGetters({
      lng: 'getExerciseLanguage',
      submittedQuesGuid: 'getSubmittedQuestionGuid'
    }),
    ...mapState({
      selectedGroup: state => state.selectedGroup
    }),
    isExam () {
      return 'classExamId' in this.$route.params
    },
    gid () {
      return this.selectedGroup.group.id
    },
    yid () {
      return this.selectedGroup.selectedYearId
    },
    sid () {
      return this.selectedGroup.id
    },
    examResults () {
      return this.$route.name === 'classExamResults' || this.$route.name === 'classExamResultsAdmin'
    }
  },
  watch: {
    submitInfo: {
      handler (newVal) {
        if (this.isExam) {
          this.tmpSubmit(newVal)
        }
      },
      deep: true
    }
  },
  methods: {
    isSurvey () {
      return false // TODO check if it is a survey
    },
    clearExercise () {
      this.submitInfo.selectedAnswer = []
      this.clearFields()
    },
    typeSet () {
      this.$nextTick(function () {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
      })
    },
    translateVhtml (arg) {
      return this.renderSiroko(this.$options.filters.pickTranslation(arg))
    },
    showSolution () {
      this.$store.dispatch('showSolution', this.submitInfo).then((data) => {
        this.isCorrect = data.correct
        this.exSolutions = data.solution
        this.doShowSolution = true
      }).then(() => {
        window.jQuery(`#${this.solutionKey}`).modal('toggle')
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    hintExercise () {
      this.$store.dispatch('hintExercise', this.submitInfo).then((data) => {
        this.isCorrect = data.correct
        this.exHints = data.hints
        this.submitInfo.hintNumber += 1
      }).then(() => {
        window.jQuery(`#${this.hintKey}`).modal('toggle')
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // tmpSubmit (newSubmitInfo) {
    //   // localStorage.setItem(this.submitInfo.entireQuestion.guid, JSON.stringify(newSubmitInfo.selectedAnswer))
    //   newSubmitInfo.submitType = 'tmp'
    //   console.log(newSubmitInfo)
    //   this.$store.dispatch('submitExercise', newSubmitInfo)
    // },
    tmpSubmit: _.debounce(function (newSubmitInfo) {
      this.submitted = false
      if (!this.examResults) {
        newSubmitInfo.submitType = 'tmp'
        this.$store.dispatch('submitExercise', newSubmitInfo).then((data) => {
          if (!newSubmitInfo.selectedAnswer || !newSubmitInfo.selectedAnswer[0]) {
            this.submitted = false
          } else if (this.isExam) {
            this.submitted = true
          }
        })
      }
    }, 800),
    evalExercise (event) {
      this.submitted = false
      this.$store.dispatch('submitExercise', this.submitInfo).then((data) => {
        this.isCorrect = data.correct
        // let height = window.jQuery(`#${this.selector}`).parent().height()
        // let scrollAmount = (event.clientY - height)
        // if (this.isCorrect) {
        //   setTimeout(() => {
        //     window.scrollBy(0, scrollAmount)
        //     // this.scrollSmoothly(scrollAmount)
        //   }, 1000)
        // }
        if (!this.isExam) {
          this.update()
          this.updateProp(this.isCorrect)
        } else {
          this.submitted = false
          setTimeout(() => { this.submitted = true }, 800)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // scrollSmoothly (am) {
    //   let x = am // y-axis pixel displacement
    //   let y = 1 // delay in milliseconds
    //   setInterval(function () {
    //     window.scroll(0, x)
    //     x = x + 1 // if you want to increase speed simply increase increment interval
    //   }, y)
    // },
    update () {
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: this.sid
      })
    },
    updateProp (correct) {
      if (correct) {
        this.$store.commit('updateIncorrectTrigger', {exerciseId: this.exerciseVersionId, correct: true})
      } else {
        this.$store.commit('updateIncorrectTrigger', {exerciseId: this.exerciseVersionId, correct: false})
      }
    }
  }
}
</script>
<style>
  .vertical {
      width: 50%;
      padding-top: 1em;
  }
</style>



// WEBPACK FOOTER //
// ExerciseEvaluation.vue?2c19adf0